import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAvailableCoupons,
  clearCoupon,
  setAvailableCoupons,
  setDiscountRemoveModal,
} from "../../../store/Cart/CartActions";
import { ALL_DELIVERY_TYPES, COUPONS } from "../../../utils/Constants";
import Btn from "../../Controls/Button/Button";
import Modal from "../../Material/Modal/Modal";
import CouponList from "../CouponList/CouponList";
import CouponSuccess from "../CouponSuccess/CouponSuccess";
import useStyles from "./Coupons.style";
import { resetWallet } from "../../../store/Profile/ProfileActions";
import useWalletPoints from "../../../CustomHooks/useWalletPoints";
import SpecialAlert from "../../SpecialAlert/SpecialAlert";

const Coupons = () => {
  const modalInit = {
    type: "",
    show: false,
  };
  const dispatch = useDispatch();
  const classes = useStyles();
  const [modal, toggleModal] = useState(modalInit);
  const [applicableCoupons, SetApplicableCoupons] = useState([]);
  const {
    selectedCoupon,
    coupons,
    priceSummary,
    isDiscountRemoveModal,
    checkoutDetails,
    data,
  } = useSelector((state) => state.cart);

  const {
    resetWalletProducts,
    RemoveItemCoupon,
    checkIsProductLoyalityApplied,
  } = useWalletPoints();

  const clearCurrentCoupon = () => {
    dispatch(resetWallet());
    resetWalletProducts(2);
    dispatch(clearCoupon());
  };

  const checkItemDiscountApplicability = (coupon) => {
    const applicableItems = coupon?.items || [];
    // const validItemsInCart = data?.filter((item) =>
    //   applicableItems.includes(item.itemId)
    // );
    const validItemsInCart =
      Number(priceSummary?.subTotal) > Number(coupon?.rules?.MIN_ORDER_VALUE) &&
      Number(priceSummary?.subTotal) < Number(coupon?.rules?.MAX_ORDER_VALUE) &&
      (coupon?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
        coupon?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES) &&
      coupon?.rules?.type === COUPONS?.ITEM_DISCOUNT;

    return validItemsInCart;
  };

  const findApplicableCoupons = () => {
    dispatch(clearAvailableCoupons());
    const newCoupons = coupons?.filter(
      (c) =>
        Number(priceSummary?.subTotal) > Number(c?.rules?.MIN_ORDER_VALUE) &&
        Number(priceSummary?.subTotal) < Number(c?.rules?.MAX_ORDER_VALUE) &&
        (c?.rules?.APPLICABLE_FOR === checkoutDetails?.orderType ||
          c?.rules?.APPLICABLE_FOR === ALL_DELIVERY_TYPES) &&
        (c?.rules?.type === COUPONS?.ITEM_DISCOUNT
          ? checkItemDiscountApplicability(c)
          : true)
    );
    dispatch(setAvailableCoupons(newCoupons));
    SetApplicableCoupons(newCoupons);
  };

  const selectCoupenHandler = (applied) => {
    toggleModal({
      ...modal,
      show: false,
    });
    if (applied) {
      toggleModal({
        type: "success",
        show: true,
      });
    }
  };

  useEffect(() => {
    findApplicableCoupons();
  }, [coupons, priceSummary]);

  const handleCouponClick = () => {
    if (checkIsProductLoyalityApplied()) {
      dispatch(setDiscountRemoveModal(true));
    } else {
      if (!selectedCoupon?.id) {
        toggleModal({ type: "coupon", show: true });
      } else {
        if (selectedCoupon?.result?.type === "ITEM_DISCOUNT") {
          RemoveItemCoupon(selectedCoupon);
          clearCurrentCoupon();
        }
        clearCurrentCoupon();
      }
    }
  };

  const handleRemoveWalletFunc = () => {
    resetWalletProducts(2);
    dispatch(resetWallet());
    dispatch(setDiscountRemoveModal(false));
    if (!selectedCoupon?.id) {
      toggleModal({ type: "coupon", show: true });
    } else {
      clearCurrentCoupon();
    }
  };

  const handleModalClick = () => {
    dispatch(setDiscountRemoveModal(false));
  };

  return (
    <div className={classes.root}>
      <Typography
        // color="primary"
        className={classes.headerTitle}
        variant="h2"
        noWrap
      >
        {"Coupons"}
      </Typography>
      <div className={`${classes.listContainerRow} align-items-center`}>
        <Typography
          // color="primary"
          className={`${classes.headerTitle} ${
            !selectedCoupon?.id && classes.headerTitleEmpty
          } m-0`}
          variant="h2"
          noWrap
        >
          {selectedCoupon?.id ? selectedCoupon.name : "Select coupon"}
        </Typography>
        <Btn
          text={!selectedCoupon?.id ? "Select" : "Remove"}
          className={`${classes.btn}`}
          handleClick={handleCouponClick}
        />
      </div>
      <Modal
        customView={true}
        open={modal.show}
        handleClose={() =>
          toggleModal({
            type: "",
            show: false,
          })
        }
        modelContainer={
          modal.type === "success" && classes.orderTypeModalContainer
        }
      >
        {modal.type === "coupon" && (
          <CouponList
            handleClose={(d) => selectCoupenHandler(d)}
            coupons={applicableCoupons || []}
          />
        )}
        {modal.type === "success" && (
          <CouponSuccess
            discount={priceSummary?.discount || 0}
            handleClose={() =>
              toggleModal({
                type: "",
                show: false,
              })
            }
          />
        )}
      </Modal>
      {
        <SpecialAlert
          open={isDiscountRemoveModal}
          isCancel={true}
          handleCloseModal={handleModalClick}
          handleClose={handleRemoveWalletFunc}
          title={
            "Applying the coupon will remove your redeemed loyalty balance. Do you want to continue?"
          }
        />
      }
    </div>
  );
};

export default Coupons;
